module.exports = __webpack_public_path__ + "img/tony_artist.1039047e.jpg";